import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.scss";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import { loginApi } from "../services/api";

function Login() {
  const navigate = useNavigate();
  const [userObj, setUserObj] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    localStorage.clear();
  }, []);

  const submit = async () => {
    let formData = { ...userObj };
    formData.email = formData.email.toLowerCase();

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    // const passwordRegex = /^[a-zA-Z0-9-_.@#$]+$/;

    console.log("formData", formData);

    // Email validation
    if (!formData.email) {
      Swal.fire({
        text: "Please enter your email address.",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    } else if (!emailRegex.test(formData.email)) {
      Swal.fire({
        text: "Please enter valid email address.",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    } else if (formData.email.length > 255) {
      Swal.fire({
        text: "Email address should be less than 255 characters",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    }

    // Password validation
    if (!formData.password) {
      Swal.fire({
        text: "Please enter password.",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    } else if (formData.password.length < 8 || formData.password.length > 16) {
      Swal.fire({
        text: "Password must be between 8 and 16 characters.",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    }

    // Loader while API call
    Swal.fire({
      html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
      showConfirmButton: false,
      heightAuto: false,
      customClass: { popup: "loader-swal" },
      allowOutsideClick: false,
    });

    try {
      const loginData = await loginApi(formData);
      console.log("loginData", loginData);
      Swal.close();

      if (loginData.status === "S") {
        localStorage.setItem("userData", JSON.stringify(loginData.result_info));

        const roleId = loginData.result_info?.user?.role_id;
        const userId = loginData.result_info?.user?.id;

        // localStorage.setItem(
        //   "correl_id",
        //   loginData.correl_id || loginData.result_info?.userAuth?.correl_id
        // );
        localStorage.setItem("role_id", roleId);
        localStorage.setItem("user_id", userId);
        localStorage.setItem(
          "created_by",
          loginData.result_info?.user?.created_by
        );
        localStorage.setItem(
          "reporting_manager_user_id",
          loginData.result_info?.user?.reporting_manager_user_id
        );

        const isFirstLogin =
          loginData.result_info?.userAuth?.is_first_time_login;
        if (isFirstLogin === true || isFirstLogin === "Y") {
          navigate("/changepassword");
          return;
        }

        if (roleId === 1) {
          navigate("/dashboard");
        } else if (roleId === 3) {
          navigate("/hiring-manager-dashboard");
        } else if (roleId === 4) {
          navigate("/requisitions");
        } else {
          navigate("/dashboard");
        }
      } else if (loginData.status === "E" || loginData.status === "F") {
        const code = loginData.result_code;

        if (code === 401) {
          if (loginData.message === "User is not active") {
            Swal.fire({
              text: "User is not active",
              icon: "warning",
              timer: 3000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              text: loginData.message || "Invalid Credentials!",
              icon: "warning",
              timer: 3000,
              showConfirmButton: false,
            });
          }
        } else if (code === 402) {
          Swal.fire({
            text: loginData.message || "Invalid Credentials!",
            showConfirmButton: false,
            icon: "warning",
            timer: 3000,
          });
        } else if (code === 404) {
          Swal.fire({
            text: loginData.message || "Invalid Credentials",
            showConfirmButton: false,
            icon: "warning",
            timer: 3000,
          });
        } else {
          Swal.fire({
            text: loginData.message || "Invalid Credentials!",
            showConfirmButton: false,
            icon: "warning",
            timer: 3000,
          });
        }
      } else {
        Swal.fire({
          text: JSON.stringify(loginData),
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
      }
    } catch (error) {
      console.error("Login error", error);
      Swal.fire({
        text: "Something went wrong!",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div className="loginContainer login-page">
      <div className="row g-0 h-100 w-100">
        <div className="col-6">
          <div className="loginLeft d-none d-lg-flex">
            <h5 className="headingText">
              <strong>Welcome to UpwardIQ Suite</strong>
            </h5>
            <img
              src={require("../assets/image.jpg")}
              alt="UpwardIQSuite"
              className="vec-image"
            />
            <p>
              A streamlined applicant tracking system to manage job
              requisitions, track candidate progress, and monitor recruitment
              activity — all in one place.
            </p>
          </div>
        </div>
        <div className="col-12 col-lg-6 h-100">
          <div className="loginRight h-100">
            <h5 className="loginText text-white">Login to your Account</h5>
            <TextField
              id="outlined-basic"
              label="Email Address"
              variant="outlined"
              className="mb-4 cust-white-input-field"
              autoComplete="off"
              value={userObj.email}
              onChange={(ev) => {
                const input = ev.target.value;
                // Regular expression to block specific patterns
                const disallowedPattern =
                  /<script.*?>.*?<\/script>|<.*?>|[<>/:?[\]\\\s|""'',;]/i;

                // Allow input only if it doesn't match the pattern
                if (!disallowedPattern.test(input)) {
                  setUserObj({ ...userObj, email: input });
                }
              }}
              inputProps={{
                maxLength: 150,
                minLength: 100,
              }}
            />
            <TextField
              id="outlined-basic"
              label="Password"
              variant="outlined"
              className="mb-4 cust-white-input-field"
              autoComplete="off"
              type={showPassword ? "text" : "password"}
              value={userObj.password}
              onChange={(ev) => {
                const input = ev.target.value;
                // const allowedPattern = /^[a-zA-Z0-9.@_\-\s]*$/;
                const allowedPattern =
                  /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]*$/;
                // Allow input only if it matches the allowed pattern
                if (allowedPattern.test(input)) {
                  setUserObj({
                    ...userObj,
                    password: input,
                  });
                }
              }}
              inputProps={{
                minLength: 8,
                maxLength: 16,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="text-white"
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onKeyDown={(ev) => {
                if (ev.key === "Enter") {
                  ev.preventDefault();
                  submit();
                }
              }}
            />
            <div className="d-lg-block d-none">
              <button
                className="btn btn-white px-4 rounded-pill text-uppercase"
                onClick={submit}
              >
                Login
              </button>
            </div>
            <div className="text-center mt-lg-3 mb-3 mb-lg-0">
              <button
                className="btn btn-light"
                onClick={() => {
                  navigate("/forgotpassword");
                }}
              >
                Forgot password?
              </button>
            </div>
            <div className="d-lg-none d-block w-100">
              <button
                className="btn btn-white px-4 rounded-pill text-uppercase "
                onClick={submit}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
